const MAX_CHROME_SOFT_BLOCK_VERSION = 119

export type BrowserSupportStatus = "browser_soft_blocked" | "not_supported" | ""

export const checkBrowserSupport = (): BrowserSupportStatus => {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)

  if (!isChrome) {
    return "not_supported"
  }

  const matches = navigator.userAgent.match(/Chrome\/(\d+)/)
  const version = matches ? parseInt(matches[1], 10) : 0

  if (version <= MAX_CHROME_SOFT_BLOCK_VERSION) {
    return "browser_soft_blocked"
  }

  return ""
}
